var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiners(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 750 471",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0079BE",
    width: 750,
    height: 471,
    rx: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 238c0-99-83-168-174-168h-78a167 167 0 100 333h78c91 1 174-74 174-165z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 84a152 152 0 101 305 152 152 0 00-1-305z",
    fill: "#0079BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237 236c0-41 26-76 62-90v180a97 97 0 01-62-90zm131 90V146a97 97 0 010 180z",
    fill: "#FFF"
  }))));
}

export default SvgDiners;